export default __webpack_public_path__ + "static/media/vijaywada.a692ccf8.png";